const Font = {
  light: 'Graphik-Light',
  medium: 'Graphik-Medium',
  regular: 'Graphik-Regular'
}

export default Font
